import type { UniclientAvatar } from '@lemonade-hq/uniclient-chat';
import React from 'react';
import jimAvatar from '../assets/jim-avatar.png';
import mayaAvatar from '../assets/maya-avatar.png';
import * as styles from './WizardAvatar.css';

const AVATAR_IMAGES = {
  maya: mayaAvatar,
  jim: jimAvatar,
} satisfies Record<UniclientAvatar, string>;

interface WizardAvatarProps {
  readonly avatar?: UniclientAvatar;
  readonly size?: 'large' | 'small';
}

export const WizardAvatar: React.FC<WizardAvatarProps> = ({ avatar = 'maya', size = 'large' }) => (
  <img alt={`${avatar} avatar`} className={styles.avatar({ size })} src={AVATAR_IMAGES[avatar]} />
);
